import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Strip generic quantity phrases so "a little bit of oil" → "oil" for storage/display */
export function normalizeFoodLabel(s: string | null | undefined): string {
  if (s == null || !s.trim()) return "";
  const t = s.trim();
  const stripped = t
    .replace(/^(a little bit of|a bit of|some|a splash of|a drizzle of|a small amount of|a touch of)\s+/i, "")
    .trim();
  return stripped || t;
}

/** Title-case a food/item string for display (e.g. "500g quark" → "500g Quark") */
export function capitalizeFoodName(s: string | null | undefined): string {
  if (s == null || !s.trim()) return "";
  return s
    .trim()
    .split(/\s+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
}
